module.exports = __webpack_public_path__ + "static/favicon-60eeccf05a4e4f8bd706eda43c0d72f2.ico";